__turbopack_context__.v({
  "crossButton": "index-module-scss-module__PVjPha__crossButton",
  "dropdownItem": "index-module-scss-module__PVjPha__dropdownItem",
  "exitButton": "index-module-scss-module__PVjPha__exitButton",
  "menuItems": "index-module-scss-module__PVjPha__menuItems",
  "overlay": "index-module-scss-module__PVjPha__overlay",
  "overlayHeader": "index-module-scss-module__PVjPha__overlayHeader",
  "profile": "index-module-scss-module__PVjPha__profile",
});
